'use client';

import { Button, ButtonGroup, Flex, Text } from '@/_components';
import { type FC, useContext } from 'react';
import { LoginContext } from '@/_contexts/LoginProvider';

export const AlternateSignIn: FC<{}> = () => {
  const { username, setLoginState } = useContext(LoginContext);

  const onBack = () => setLoginState('login');

  return (
    <form>
      <Flex isColumn={true} gap={8} padding={10}>
        <Text type="small" color="secondary">
          We’ve sent an email to <b>{username}</b> with a link to reset your
          sign-in method.
        </Text>

        <ButtonGroup>
          <Button
            iconLeft="arrow-left"
            value="Back"
            type="button"
            onClick={onBack}
            intent="primary"
          />
        </ButtonGroup>
      </Flex>
    </form>
  );
};
